import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CHART_GRID_COLOR, CHART_AXIS_TICK_STYLE } from './chartPalette';
import { CustomChartTooltip } from './CustomChartTooltip';
import { ChartCard } from '@/components/ui/chart-card';

interface WeekEntry { weekStartDate: string; totalPosts: number; }

/**
 * PostsPerWeekBarChart — re-skinned for PR (m.8) Phase 2 onto the
 * canonical `<ChartCard>` chrome.
 */
export function PostsPerWeekBarChart({ entries }: { entries: WeekEntry[] }) {
  if (!entries || entries.length === 0) {
    return (
      <ChartCard eyebrow="Posts Per Week" title="Across Program">
        <div className="py-6 text-center text-eyebrow-sm text-muted-foreground">
          No data yet
        </div>
      </ChartCard>
    );
  }
  return (
    <ChartCard eyebrow="Posts Per Week" title="Across Program">
      <div style={{ width: '100%', height: 280 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={entries} margin={{ top: 8, right: 16, left: 8, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={CHART_GRID_COLOR} />
            <XAxis dataKey="weekStartDate" tick={CHART_AXIS_TICK_STYLE} stroke={CHART_GRID_COLOR} />
            <YAxis tick={CHART_AXIS_TICK_STYLE} stroke={CHART_GRID_COLOR} />
            <Tooltip content={<CustomChartTooltip />} />
            <Bar dataKey="totalPosts" name="Posts" fill="#876a1e" isAnimationActive={false} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </ChartCard>
  );
}
